<div *ngIf="accessDenied" class="container mt-3">Access Denied</div>

<div *ngIf="!accessDenied" class="container mt-3">
  <h2 class="mb-3">Analytics</h2>

  <div class="row g-2 mb-4 align-items-end">
    <div class="col-auto">
      <label class="form-label">Start</label>
      <input type="date" class="form-control" [(ngModel)]="startDate" (change)="loadAnalytics()">
    </div>
    <div class="col-auto">
      <label class="form-label">End</label>
      <input type="date" class="form-control" [(ngModel)]="endDate" (change)="loadAnalytics()">
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" (click)="loadAnalytics()">Load</button>
    </div>
    <div class="col d-flex flex-wrap gap-2">
      <button class="btn btn-outline-secondary" (click)="setQuickRange(30)">30 Days</button>
      <button class="btn btn-outline-secondary" (click)="setQuickRange(90)">3 Months</button>
      <button class="btn btn-outline-secondary" (click)="setQuickRange(180)">6 Months</button>
      <button class="btn btn-outline-secondary" (click)="setQuickRange(365)">1 Year</button>
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <div class="row g-4">
      <div class="col-lg-6">
        <h4>Frequent players</h4>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th (click)="sortBy('fullName')">Player <i class="ms-1" [ngClass]="getSortIcon('fullName')"></i></th>
              <th (click)="sortBy('email')">Email <i class="ms-1" [ngClass]="getSortIcon('email')"></i></th>
              <th (click)="sortBy('reservations')">Reservations <i class="ms-1" [ngClass]="getSortIcon('reservations')"></i></th>
              <th>VIP Note</th>
              <th>VIP Action</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let p of frequentPlayers">
                <td [ngClass]="{'vip-name': p.isVip}">{{p.fullName}} <span *ngIf="p.username" class="text-muted">({{p.username}})</span></td>
                <td>{{p.email}}</td>
                <td>{{p.reservations}}</td>
                <td>{{p.vipNote}}</td>
                <td>
                  <button class="btn btn-sm" [ngClass]="p.isVip ? 'btn-outline-danger' : 'btn-outline-primary'" (click)="toggleVip(p)">
                    {{ p.isVip ? 'Remove VIP' : 'Make VIP' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="col-lg-6">
        <h4>Daily population</h4>
        <canvas baseChart [data]="dailyPopulationData" [options]="dailyChartOptions" type="line"></canvas>
      </div>

      <div class="col-lg-6">
        <h4>Weekly occupancy</h4>
        <canvas baseChart [data]="weeklyOccupancyData" [options]="chartOptions" type="bar"></canvas>
      </div>

      <div class="col-lg-6">
        <h4>Court usage</h4>
        <canvas baseChart [data]="courtUsageData" [options]="chartOptions" type="bar"></canvas>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="d-flex justify-content-center my-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </ng-template>

  <p-dialog
    header="VIP Note"
    [(visible)]="vipDialogVisible"
    [modal]="true"
    [closable]="false"
  >
    <div class="p-field">
      <label for="vipNote">VIP Note (optional)</label>
      <input id="vipNote" type="text" pInputText [(ngModel)]="vipNoteText" />
    </div>
    <p-footer>
      <button
        pButton
        label="Cancel"
        icon="pi pi-times"
        class="p-button-text"
        (click)="vipDialogVisible=false"
      ></button>
      <button
        pButton
        label="Submit"
        icon="pi pi-check"
        (click)="submitVip()"
      ></button>
    </p-footer>
  </p-dialog>
</div>
